import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './programmation.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function ProgrammationIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
